import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import Heading from '../../components/Heading/Heading';
import ContentSidebar from '../../components/ContentSidebar/ContentSidebar';
import DocumentRequestForm from '../../components/Shared/DocumentRequestForm';
import FreeDocuments from '../../components/Shared/FreeDocuments';
import InstantDocuments from '../../components/Shared/InstantDocuments';
import LoanApplicationPackage from '../../components/Shared/LoanApplicationPackage';
import Card from '../../components/Card/Card';
import theme from '../../styles/theme';
import useGTM from '../../hooks/useGTM';
import createGTMClass from '../../util/createGTMClass';
import CTACardv2 from '../../components/CTACardv2/CTACardv2';

function DocumentsAndForms({ isLoading = false }) {
  const [triggerGTMEvent] = useGTM();

  return (
    <Layout isLoading={isLoading}>
      <SEO
        title='Home Loan Documents and Forms'
        description='Find all the documents and forms needed to complete our home loan application from Vanderbilt Mortgage.'
      />
      <Heading background={theme.colors.blue10} appearance='dark'>
        <h1>Documents & Forms</h1>
      </Heading>

      <ContentSidebar
        sidebar={
          <>
            <FreeDocuments
              className={createGTMClass('sign_in', 'cta', 'button')}
              onSignin={triggerGTMEvent({
                name: 'vmf.cta_click',
                location: 'Documents',
                category: 'account_sign_in',
                action: 'button',
                label: 'sign_in',
              })}
            />
            <InstantDocuments />
            <LoanApplicationPackage>
              <h2 className='type-h4'>Loan Application Package</h2>
              <p className='type-caption'>
                Please choose your state below. If your state does not appear in
                the drop down list, Vanderbilt Mortgage and Finance, Inc. is not
                originating loans in that state.
              </p>
            </LoanApplicationPackage>
          </>
        }
        background={theme.colors.white}
      >
        <Card>
          <DocumentRequestForm
            className={createGTMClass('form', 'form', 'button')}
            onFeesClick={triggerGTMEvent({
              name: 'vmf.cta_click',
              location: 'Documents',
              category: 'loan_education',
              action: 'text',
              label: 'fees_charges',
            })}
            onCheckboxClick={label =>
              triggerGTMEvent({
                name: 'vmf.cta_click',
                location: 'Documents',
                category: 'customer_support',
                action: 'checkbox',
                label,
              })
            }
            onSubmit={triggerGTMEvent({
              name: 'vmf.cta_click',
              location: 'Documents',
              category: 'customer_support',
              action: 'form',
              label: 'docs_forms_submit',
            })}
          />
        </Card>
      </ContentSidebar>

      <CTACardv2
        preHeaderContent={'Have Questions?'}
        headerContent={`We're Here to Help`}
        buttonText={'Contact Us'}
        buttonUrl={'/contact-us/'}
        gtmClassName={'contact'}
        ctaIntro={
          <>
            <p>
              Existing customers <a href='tel:1-800-970-7250'>1-800-970-7250</a>
            </p>
            <p>
              New customers <a href='tel:1-866-701-0467'>1-866-701-0467</a>
            </p>
          </>
        }
      />
    </Layout>
  );
}

DocumentsAndForms.getInitialProps = async ({}) => {
  try {
    // Fetch server-rendered data here
    return { data: {} };
  } catch (error) {
    // Handle issues loading data
    if (error.response.status === 404) return { statusCode: 404 };
    return { error };
  }
};

DocumentsAndForms.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default DocumentsAndForms;
